import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/5bb4e3dd-8f53-44c5-a5ed-987c732eaf8f",
        "alt": "An image showing a card with a Copilot Octicon."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use cards to summarize the central idea behind some content and provide a link to its corresponding detailed resource. It is important to present the information in a concise manner, avoiding lengthy and complex descriptions.`}</p>
    <p>{`Cards should always be used in groups of two or more related concepts.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/139deb0e-0143-4051-a8c8-49b854b58727" />
    <Caption mdxType="Caption">Use cards in groups to display related information.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/1f009b98-01b8-4cb3-af30-83ccac31c8c9" />
    <Caption mdxType="Caption">
      Don't use isolated cards. Consider using a CTABanner instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Stacked`}</h3>
    <p>{`Cards should be stacked to display a list of items that are related to each other. If displaying a visual asset, do so for all cards to achieve a visually balanced layout. The visual asset should be the same type for all cards, either an icon or an image.`}</p>
    <p>{`For a better visual experience, we recommend using similar length size for the heading and description in all stacked cards.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/28b8dbfa-9ed5-40ba-b1a3-d501ac3be4b8" />
    <Caption mdxType="Caption">
      Use the same type of visual asset for all cards and a similar length size
      for the content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/6d494165-312e-4e84-94df-199d1d82fd50" />
    <Caption mdxType="Caption">
      Don't use different length sizes for the title or the description.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`When using an image as the visual asset, we recommend using the same aspect ratio for all images. This will create a more balanced visual experience.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/1a6decfc-a840-440b-8ec7-bf25b7716711" />
    <Caption mdxType="Caption">
      Use the same image ratio and a similar length sizes for the content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/cffafadf-2e9d-47f0-a6db-6f89fb48fabe" />
    <Caption mdxType="Caption">
      Don't use different image ratios and a different length size for the
      content.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Cards typically appear in groups of three or four in desktop viewports. For smaller viewports, or when more than four cards are needed, we recommend stacking the cards vertically. You can use the `}<a parentName="p" {...{
        "href": "/components/Grid"
      }}>{`Grid`}</a>{` or the `}<a parentName="p" {...{
        "href": "/components/Stack"
      }}>{`Stack`}</a>{` component to achieve this.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/6951037/a9ceec00-59c9-4471-a274-f516790f43c9" mdxType="CustomVideoPlayer" />
  <Caption mdxType="Caption">
    Stack cards vertically so that the content has enough line length.
  </Caption>
    </div>
    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/2ae395d0-227d-4794-8e0b-f709a431e636",
        "alt": "An image showing the card anatomy with an icon as a visual asset, a heading, a description and a CTA text in a vertical order."
      }}></img></p>
    <h3>{`Visual asset`}</h3>
    <p>{`The visual asset is optional and can be an image or an icon. It can be used to provide a visual cue to the user about the content of the card. To avoid visual noise, we recommend using only one icon or image, but not both in the same card.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/21623e82-2ea5-499a-a78f-82b09915af16",
        "alt": "An image showing two cards, one with an Icon and another with an Image as the visual assets options."
      }}></img></p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/e5494fd3-76b1-45fd-8aa7-4acfe834b159" />
    <Caption mdxType="Caption">Use only one visual asset per card.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/bc29b10b-ee0b-421d-8bc4-0a95fad3791b" />
    <Caption mdxType="Caption">Don't use both icon and image as the visual asset.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Label`}</h3>
    <p>{`The label can be used to indicate the type of content or its status. For example, use it to indicate that the content is `}<inlineCode parentName="p">{`new`}</inlineCode>{` or that it is a `}<inlineCode parentName="p">{`beta`}</inlineCode>{` feature. The label is optional and can be used along with a visual asset.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/3e16bb51-9e19-4a98-a9c2-e289d4bf540c",
        "alt": "An image showing two cards, one with a Label and another one with Label and Icon."
      }}></img></p>
    <h3>{`Heading`}</h3>
    <p>{`The heading is the main title of the card. It should be short and concise.`}</p>
    <h3>{`Description`}</h3>
    <p>{`The description is an optional short text that extends the information provided by the heading.`}</p>
    <h3>{`Call to action`}</h3>
    <p>{`The call to action label indicates the action or resource the card links to. It defaults to "Learn more".`}</p>
    <h2>{`Options`}</h2>
    <h3>{`Border`}</h3>
    <p>{`Card offers a variation with a border. Border is disabled by default. `}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To display a single block of content to draw attention or create urgency around a user action.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/UnorderedList"
        }}>{`UnorderedList`}</a>{` or the `}<a parentName="li" {...{
          "href": "/components/OrderedList"
        }}>{`OrderedList`}</a>{`: to display a list of plain content items.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      